import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PaymentsActions } from "store/ducks/points";
import swal from "sweetalert";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Points/CPFList/components";
import { Redirect } from "react-router";
import points from "services/points";

const Create = ({ user }) => {
  const [data, setData] = useState({});

  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState("");
  const [redirect, setRedirect] = useState(false);

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "Pontos", to: "/points" },
    { name: "Listagem (Pontos - Lista de CPFs)", to: "/points/cpf-list" },
    { name: "Atribuir Pontos para uma Lista de CPFs", to: "" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.inhabitants) {
      setErrors("É necessário informar o CSV.");
      return swal(
        "Dados inválidos!",
        "Você precisa inserir o CSV com os dados.",
        "error"
      );
    }

    const inhabitants = data.inhabitants;

    if (inhabitants[inhabitants.length - 1]?.cpf === "") {
      inhabitants.pop();
    }

    if (!inhabitants.length) {
      setErrors("É necessário informar o CSV.");
      return swal(
        "Dados inválidos!",
        "Você precisa inserir o CSV com os dados.",
        "error"
      );
    }

    for (let { cpf, number_of_points } of inhabitants) {
      if (cpf || number_of_points) {
        cpf = cpf.replace(/\D/g, "").trim();
        number_of_points = Number(number_of_points);

        if (isNaN(number_of_points)) {
          setErrors("O número de pontos deve ser um valor numérico.");
          return swal(
            "Número de pontos inválido!",
            "O número de pontos deve ser um valor numérico.",
            "error"
          );
        }

        if (String(cpf).length !== 11) {
          setErrors("O CPF informado é inválido.");
          return swal("CPF inválido!", `O CPF ${cpf} é inválido.`, "error");
        }
      }
    }

    setSaving(true);

    const payload = {
      bulk_points_assigner: {
        name: user.data.attributes.name,
        experience_doc_points_assigners_attributes: inhabitants,
        score_reason: data.reason,
      },
    };

    points
      .post("experience/bulk_points_assigner", payload)
      .then(() => {
        setData({});
        swal(
          "Pontos atualizado",
          "Os pontos do habitante foram atualizados com sucesso.",
          "success"
        ).then(() => setRedirect(true));
      })
      .catch(() => {
        setSaving(false);
        swal(
          "Erro ao atualizar pontos",
          "Ocorreu um erro ao atualizar os pontos do habitante.",
          "error"
        );
      });
  };

  if (redirect) {
    return <Redirect to="/points/cpf-list" />;
  }

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Form
        data={data}
        errors={errors}
        saving={saving}
        onChange={(newData) => setData(newData)}
        onSubmit={handleSubmit}
      />
    </Page>
  );
};

const mapState = (state) => ({
  user: state.auth.user,
});

const mapActions = (dispatch) => bindActionCreators(PaymentsActions, dispatch);

export default connect(mapState, mapActions)(Create);
